module.exports = __webpack_public_path__ + "img/1511993981.9cb9ca44.jpg";